export const optionsConstants = {
    UPDATE: '[Options] Update Option',
}
